/**
 * Formato exemplo:
 * {
        name: {
          value: '',
          error: false,
          errorMessage:''
        },
        email: {
          value: '',
          error: false,
          errorMessage:''
        },
        colums: {
          "name": {
            value: "Nome"
          },
          "email": {
            value: "Email"
          },
        },
    }
 * @param {Object} formValues 
 */
export const stringifyValues = (formValues) => {

	var values = {};

	for (const [key, item] of Object.entries(formValues)) {

		if (typeof item === 'object') {

			let subitem = {};

			for (const [key2, item2] of Object.entries(item)) {

				if (key2 === 'value') {

					values[key] = item.value;

				} else {

					if (item2.hasOwnProperty('value')) {

						subitem[key2] = item2.value;
						values[key] = subitem;

					}

				}

			}

		}

	}

	return JSON.stringify(values);

};

/**
 * Função ser para retornar o nome do campo e indice de um field name no formato columns[name];
 * Nome do campo
 * @param {string} name 
 */
export const fieldNameIndex = (name) => {

	const fieldName = name.replace(/\[[a-zA-Z0-9_-]*\]/g, '');
	const fieldIndex = name.replace(new RegExp(`${fieldName}|[^a-zA-Z0-9_-]`, 'g'), '');	

	return { fieldName: fieldName, fieldIndex: fieldIndex };

};

/**
 * 
 * @param {obeject} valuesObject - objeto a ser alterado
 * @param {string} index - indice do objeto a ser altedado
 * @param {*} value  - valor a ser atualizado no indice
 */
export const mergeValue = (valuesObject, index, value) => {

	if (typeof value === 'object') {
		return { ...valuesObject, [index]: { ...valuesObject[index], ...value } };
	}

	return { ...valuesObject, [index]: { ...valuesObject[index], value } };

};
